import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import useSmoothResponsiveFontSize from "../../../../_hook/useSmoothResponsiveFontSize";

const StyledTypography = styled(Typography)(({ theme, customfontsize }) => ({
  margin: '10px  0px',
  display: "block",
  width: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: `${1.5 * customfontsize}px`,
  textDecoration: "none",
  textTransform: "capitalize",
  position: "relative", // Set position relative to allow absolute positioning of the line

  // Hover effect styling with animation
  "&:hover": {
    color: theme.palette.grey[700], // Change color on hover
    textDecoration: "none", // Remove text decoration
    animation: "colorChange 0.3s ease-in-out", // Animation for color change
  },

  cursor: "pointer", // Optional, adds a pointer cursor on hover

  '& span': {
    position: 'relative',
    display: 'inline-block', // Ensures underline matches span text width
  },
  '& span:hover::after': {
    content: "''",
    position: "absolute",
    bottom: 0,
    left: 0,
    width: `calc(100%)`,
    height: "2px", // Adjust underline thickness
    backgroundColor: theme.palette.primary.main, // Adjust underline color
    animation: "underlineAnimation 0.3s ease-in-out", // Animation for underline
  },

  // Keyframes for color change animation
  "@keyframes colorChange": {
    "0%": {
      color: theme.palette.text.primary, // Initial text color
    },
    "100%": {
      color: theme.palette.grey[700], // Final color on hover
    },
  },

  // Keyframes for underline animation
  "@keyframes underlineAnimation": {
    "0%": {
      width: "0%", // Start with no underline
    },
    "100%": {
      width: "100%", // Full width underline on hover
    },
  },
}));

const CourseCardTitle = ({ courseTitle,customfontsize }) => {
 

  return (
    <StyledTypography
      variant="h6"
      component={Link}
      to={"/course-details"}
      fontWeight={"bold"}
      customfontsize={customfontsize}
      aria-label={`View details for ${courseTitle}`}
    >
      <span>{courseTitle}</span>
    </StyledTypography>
  );
};

export default CourseCardTitle;
